export default "__VITE_ASSET__fd63382c__"